import YearFields from '../components/YearFields';
import { datingDraft, datingPayload } from '../utils/dating';
import React, { useState, useEffect } from 'react';
import { fetchProducts, fetchManufacturers, submitChangeRequest } from '../api';
import { useNavigate } from 'react-router-dom';
import SearchableSelect from '../components/SearchableSelect';
import RichTextEditor from "../components/RichTextEditor";
import PhotoUploader, { uploadButtonLabel, usePhotoUploads } from '../components/PhotoUploader';

export default function ProductForm() {
  const [dating, setDating] = useState(() => datingDraft());
  const [product, setProduct] = useState({
    name: '',
    description: '',
    source: '',
    belongsTo: '',
    parentId: null,
    year: '',
    number: '',
    manufacturerId: ''
  });
  const uploads = usePhotoUploads();

  const [products, setProducts] = useState([]);
  const [manufacturers, setManufacturers] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts().then(r => setProducts(r.data)).catch(console.error);
    fetchManufacturers().then(r => setManufacturers(r.data)).catch(console.error);
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setProduct(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (uploads.busy) return;
    if (uploads.failedCount && !window.confirm('Часть фото не загрузилась. Создать изделие без них?')) return;
    setSaving(true);
    setError(null);

    const auth = JSON.parse(localStorage.getItem("auth") || "{}");
    const isModerator = auth?.role === 'MODERATOR' || auth?.role === 'ADMIN';

    try {
      await submitChangeRequest({
        action: 'CREATE',
        entityType: 'PRODUCT',
        entityId: null,
        payload: {
          name: product.name,
          description: product.description,
          source: product.source,
          belongsTo: product.belongsTo || null,
          number: product.number?.trim() || null,
          ...datingPayload(dating),
          parent: product.parentId ? { id: product.parentId } : null,
          manufacturer: product.manufacturerId ? { id: product.manufacturerId } : null,
          photos: uploads.photos.map(photo => ({ id: photo.id }))
        }
      });

      if (!isModerator) {
        alert('Заявка отправлена на модерацию');
      } else {
        alert('Изделие сразу добавлено (вы модератор)');
      }

      setProduct({
        name: '',
        description: '',
        source: '',
        belongsTo: '',
        parentId: null,
        year: '',
        number: '',
        manufacturerId: ''
      });
      setDating(datingDraft());
      uploads.reset();
      //navigate('/products');
    } catch (err) {
      console.error(err);
      setError(err.message || 'Ошибка при создании изделия');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 bg-gray-900 p-6 rounded-lg text-white">
      <h2 className="text-xl font-semibold mb-2">Создать изделие</h2>
      {error && <p className="text-red-500">{error}</p>}

      <div className="p-4 bg-gray-800 border-l-4 border-yellow-500 rounded">
        <p className="mb-2 font-semibold text-yellow-500">Обязательное поле</p>
        <div className="space-y-3">
          <div>
            <input
              name="name"
              required
              className="w-full p-2 bg-gray-800 border border-gray-600 rounded"
              placeholder="Название"
              value={product.name}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      <div>
        <label className="block mb-1 text-sm text-gray-300">Описание</label>
        <RichTextEditor
          value={product.description}
          onChange={(value) =>
            setProduct((prev) => ({ ...prev, description: value }))
          }
          placeholder="Введите описание"
        />
      </div>
      <input
        name="source"
        className="w-full p-2 bg-gray-800 border border-gray-600 rounded"
        placeholder="Источник / сайт"
        value={product.source}
        onChange={handleChange}
      />
      <YearFields value={dating} onChange={setDating} />
      <input
        name="number"
        className="w-full p-2 bg-gray-800 border border-gray-600 rounded"
        placeholder="Номер"
        value={product.number}
        onChange={handleChange}
      />


      <SearchableSelect
        options={[
          { id: 'максим', name: 'Максим' },
          { id: 'станок', name: 'Станок' },

          { id: 'ЗИП', name: 'ЗИП' }
        ]}
        value={product.belongsTo}
        onChange={(val) => setProduct((prev) => ({ ...prev, belongsTo: val }))}
        placeholder="— Назначение —"
      />

      <SearchableSelect
        options={manufacturers}
        value={product.manufacturerId}
        onChange={(val) => setProduct((prev) => ({ ...prev, manufacturerId: val }))}
        placeholder="— Производитель —"
      />

      <SearchableSelect
        options={products}
        value={product.parentId}
        onChange={(val) => setProduct((prev) => ({ ...prev, parentId: val }))}
        placeholder="— Без родителя —"
      />

      <PhotoUploader uploads={uploads} />

      <button
        type="submit"
        disabled={saving || uploads.busy}
        className="w-full px-6 py-2 mt-4 bg-green-600 hover:bg-green-700 text-white font-semibold rounded disabled:opacity-50 disabled:cursor-wait"
      >
        {saving ? 'Сохраняем…' : uploadButtonLabel(uploads, 'Создать изделие')}
      </button>
    </form>
  );
}
